import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=15c41770&scoped=true"
import script from "./SearchBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchBar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=15c41770&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c41770",
  null
  
)

export default component.exports